import { render, staticRenderFns } from "./MyRecipesIndex.vue?vue&type=template&id=131ed700&"
import script from "./MyRecipesIndex.vue?vue&type=script&lang=js&"
export * from "./MyRecipesIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports